import axios from "axios";

const API_CONTROLLER = "/CommandNControlNotification";

const AdminNotificationService = {
  getUnreadNotifications: async () => {
    const response = await axios.get(
      `${API_CONTROLLER}/unread`
    );
    return response.data;
  },

  markAsRead: async (notificationId: number) => {
    const response = await axios.put(
      `${API_CONTROLLER}/markAsRead/${notificationId}`
    );
    return response.data;
  },

  markAllAsRead: async () => {
    const response = await axios.put(
      `${API_CONTROLLER}/markAllAsRead`
    );
    return response.data;
  }
};

export default AdminNotificationService;
